export const appConfig = {
  env: process.env.VUE_APP_ENV_NAME as string,
  logLevel: process.env.VUE_APP_LOG_LEVEL as string,
  apiPath: process.env.VUE_APP_API_PATH as string,
  fetchData: process.env.VUE_APP_FETCH_DATA as string,
};



// WEBPACK FOOTER //
// ./src/config/app.config.ts